import Button from 'src/components/atoms/button/button';
import Table from 'src/components/atoms/table/table';
import { RoleWithCapabilities } from 'src/models/user.model';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { openModal } from 'src/reducers/modal.reducer';
import { ProfilesAndAuthorizationsDetails } from '../profiles-and-authorizations-modals/profilesAndAuthorizationsDetails';
import { EDIT_CAPABILITIES_PERMISSION, isAuthorizedToHandleCapability } from '../../../../utils/capability-utils';
import { DeleteRoleModal } from '../profiles-and-authorizations-modals/deleteRoleModal';
import { EditRoleNameModal } from '../profiles-and-authorizations-modals/editRoleNameModal';
import { Icon } from '../../../atoms/icon';

type Props = {
  roleWithCapabilities: RoleWithCapabilities;
};

export const ProfileTableCard = (props: Props) => {
  const { roleWithCapabilities: profile } = props;
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.authentication);

  const openProfileDetails = () => {
    dispatch(
      openModal({
        children: <ProfilesAndAuthorizationsDetails role={profile.role} capabilitiesRole={profile.capabilities} />,
        opt: {
          size: 'lg',
          type: 'default',
          title: `Gestisci le autorizzazioni legate al ruolo ${profile.role.name}`,
        },
      })
    );
  };

  const openDeleteRoleModal = () => {
    dispatch(
      openModal({
        children: <DeleteRoleModal role={profile.role} />,
        opt: {
          size: 'xs',
          type: 'default',
          title: 'Conferma eliminazione profilo',
        },
      })
    );
  };

  const openEditRoleNameModal = () => {
    dispatch(
      openModal({
        children: <EditRoleNameModal role={profile.role} />,
        opt: {
          size: 'xs',
          type: 'default',
          title: 'Modifica nome',
        },
      })
    );
  };

  return (
    <Table.Row>
      <Table.Cell>{profile?.role.name}</Table.Cell>
      <Table.Cell>
        <div>{`${profile.capabilities.length} ${profile.capabilities.length !== 1 ? 'autorizzazioni' : 'autorizzazione'}`}</div>
      </Table.Cell>
      <Table.Cell align="right">
        {user && isAuthorizedToHandleCapability(user, EDIT_CAPABILITIES_PERMISSION) && (
          <>
            <Button onClick={openProfileDetails}>
              <Icon content="list" />
            </Button>
            <Button onClick={openEditRoleNameModal}>
              <Icon content="edit" />
            </Button>
            {profile.capabilities.length === 0 && (
              <Button onClick={openDeleteRoleModal}>
                <Icon content="trash" />
              </Button>
            )}
          </>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
